import React, { Component } from 'react';
import WithAuth from 'HOC/Auth/WithAuth';
import styles from './MainGreeting.module.css';

import hafaryImg from '../../assets/hafary.jpg';

const Container = props => {
  return (
    <div className={props.className}>
      <img className={styles.Image} src={hafaryImg} alt="hafary" />
      <hr />
      {props.children}
    </div>
  );
};

export default WithAuth(
  class extends Component {
    renderRedirect = () => {
      const { redirectHandler } = this.props;
      return (
        <Container className={this.props.className}>
          <span className={styles.Span}>
            Please{' '}
            <a className={styles.A} onClick={redirectHandler}>
              {' '}
              login
            </a>
          </span>
        </Container>
      );
    };

    renderGreeting = () => {
      return (
        <Container className={this.props.className}>
          <span className={styles.Span}>
            <strong>Welcome</strong>
          </span>
          <span className={styles.Span2}>Access level: {this.props.retrieveRole()}</span>
        </Container>
      );
    };

    render() {
      if (!this.props.isLoggedIn()) return this.renderRedirect();
      else return this.renderGreeting();
    }
  },
);



// WEBPACK FOOTER //
// ./src/components/Greeting/MainGreeting.js